import React, { useState } from 'react';
import { HerokuURL } from '../../constants';
import { Alert, Snackbar, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';



const ConfirmationModal = (props) => {

  const [snack, setSnack] = useState({ message: "", duration: 0, open: false, severity: "success" })




  const handleClose = () => {
    props.handleClose();
  }

  const closeSnack = () => {
    setSnack({ ...snack, open: false });
  }

  const onSubmit = async () => {

    var deleteUserResponse = fetch(`${HerokuURL}api/deleteUser`, {
      method: 'DELETE',
      headers: {
        "x-access-token": localStorage.getItem('accessToken'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        props.user
      ),
    })


    deleteUserResponse.then((response) => response.json()).then((data) => {

      setSnack({ open: true, duration: 6000, message: "User Deleted" });
      setTimeout(function () {
        handleClose();
      }, 2000);

    });
  }




  return (
    <>

      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={snack.open} autoHideDuration={snack.duration} onClose={closeSnack}>
        <Alert onClose={closeSnack} variant="filled" severity={snack.severity} sx={{ width: '100%' }}>
          {snack.message}
        </Alert>
      </Snackbar>
      <Dialog size="lg" open={true} onHide={handleClose}>
        <DialogTitle style={{ "borderBottom": "1px solid lightgrey" }}> Delete User
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton></DialogTitle>
        <DialogContent>
          Are you sure you want to delete this user?


        </DialogContent>
        <DialogActions style={{ "borderTop": "1px solid lightgrey" }}>
          {/* TODO: if form updated open dialog that tells user all changes made will be lost, are you sure you want to close */}
          {/* <Button variant="outlined" size="large" onClick={handleClose}>{sangatValue._id ? "Close" : "Cancel"}</Button> */}
          <Button variant="outlined" onClick={handleClose}>
            Close
          </Button>

          <Button variant="contained" onClick={onSubmit}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );



}
export default ConfirmationModal;